























































































































































































































































































































































































import {
  computed,
  SetupContext,
  defineComponent,
  useStore
} from '@nuxtjs/composition-api'
import { FooterInfo } from '@/contracts/Settings'
import ContactBlock from '@/components/ContactBlock.vue'
import BlockText from '@/components/BlockText.vue'
import Link from '@/components/Link.vue'
import CityFromCookie from '@/components/CityFromCookie'

export default defineComponent({
  name: 'Footer',
  components: {
    ContactBlock,
    Link,
    BlockText,
    CityFromCookie,
  },
  setup(_props, ctx: SetupContext) {
    const store = useStore()
    const showCityPopup = () => store.commit('popupCityList/SET_SHOWN', true)
    const footerInfo = computed(
      () => ctx.root.$store.getters['settings/footerInfo'] as FooterInfo
    )
    const cookie = computed(() => ctx.root.$store.getters['settings/cookie'])
    const isMobile = computed(
      () => ctx.root.$store.getters['mediaQuery/isMobileMq']
    )
    const isDesktop = computed(
      () => ctx.root.$store.getters['mediaQuery/isDesktopMq']
    )
    const updatedTime = computed(
      () => ctx.root.$store.getters['settings/getUpdatedTime']
    )

    const formatDate = (isoDate: string): string => {
      if (!isoDate) return ''
      const date = new Date(isoDate)
      const day = ('0' + date.getDate()).slice(-2)
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const year = date.getFullYear()
      return `${day}.${month}.${year}`
    }

    const formattedUpdatedTime = computed(() => formatDate(updatedTime.value))

    return {
      footerInfo,
      cookie,
      isMobile,
      isDesktop,
      formattedUpdatedTime,
      showCityPopup
    }
  },
})
